import React from 'react';
import Icon from '../components/icons';

export default function AnalyticsPage() {
  const orders = (() => { try { return JSON.parse(localStorage.getItem('amorlia_orders') || '[]'); } catch { return []; } })();
  const catalog = (() => { try { return JSON.parse(localStorage.getItem('amorlia_catalog') || '[]'); } catch { return []; } })();
  const queue = (() => { try { return JSON.parse(localStorage.getItem('amorlia_extract_queue') || '[]'); } catch { return []; } })();

  const totalRevenue = orders.reduce((s, o) => s + (parseFloat(o.price) || 0) * (parseInt(o.quantity) || 1), 0);
  const totalCost = orders.reduce((s, o) => s + (parseFloat(o.sourceCost) || 0), 0);
  const totalProfit = totalRevenue - totalCost;
  const avgMargin = totalRevenue > 0 ? ((totalProfit / totalRevenue) * 100).toFixed(1) : 0;

  const stats = [
    { label: 'Total Products', value: catalog.length + queue.length, color: '#FF6B35' },
    { label: 'Published', value: catalog.filter(c => c.catalogStatus === 'published').length, color: '#2ED573' },
    { label: 'Total Revenue', value: `$${totalRevenue.toFixed(2)}`, color: '#3B82F6' },
    { label: 'Total Profit', value: `$${totalProfit.toFixed(2)}`, color: totalProfit >= 0 ? '#2ED573' : '#FF4757' },
    { label: 'Avg Margin', value: `${avgMargin}%`, color: avgMargin >= 30 ? '#2ED573' : '#FFA502' },
    { label: 'Orders', value: orders.length, color: '#8B5CF6' },
  ];

  // Supplier breakdown
  const supplierCounts = {};
  queue.forEach(q => {
    const s = q._source || q.sourceSite || 'unknown';
    supplierCounts[s] = (supplierCounts[s] || 0) + 1;
  });

  return (
    <div>
      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.25rem', color: 'var(--color-text-primary)' }}>Analytics & Profit</h2>
        <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.875rem' }}>Full analytics dashboard coming in Phase 2.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
        {stats.map(s => (
          <div key={s.label} className="glass-card" style={{ padding: '1rem' }}>
            <div style={{ fontSize: '0.7rem', color: 'var(--color-text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.375rem' }}>{s.label}</div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Supplier breakdown */}
      {Object.keys(supplierCounts).length > 0 && (
        <div className="glass-card" style={{ padding: '1.25rem', marginBottom: '1.5rem' }}>
          <h3 style={{ fontSize: '0.9rem', fontWeight: 600, marginBottom: '0.75rem', color: 'var(--color-text-primary)' }}>Supplier Breakdown</h3>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            {Object.entries(supplierCounts).map(([supplier, count]) => (
              <div key={supplier} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#FF6B35' }} />
                <span style={{ fontSize: '0.8rem', color: 'var(--color-text-primary)', textTransform: 'capitalize' }}>{supplier}</span>
                <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontFamily: 'monospace' }}>{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Top performers */}
      {catalog.length > 0 && (
        <div className="glass-card" style={{ padding: '1.25rem' }}>
          <h3 style={{ fontSize: '0.9rem', fontWeight: 600, marginBottom: '0.75rem', color: 'var(--color-text-primary)' }}>Top Products</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {catalog
              .filter(c => c.rawNihaoPrice && c.price)
              .sort((a, b) => ((b.price - (b.rawNihaoPrice || 0)) / (b.price || 1)) - ((a.price - (a.rawNihaoPrice || 0)) / (a.price || 1)))
              .slice(0, 5)
              .map((item, i) => {
                const margin = item.price > 0 ? ((item.price - (item.rawNihaoPrice || 0)) / item.price * 100).toFixed(1) : 0;
                return (
                  <div key={item.id || i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.5rem 0', borderBottom: '1px solid var(--color-border)' }}>
                    <span style={{ fontSize: '0.7rem', color: 'var(--color-text-muted)', width: 20 }}>{i + 1}</span>
                    <span style={{ flex: 1, fontSize: '0.8rem', color: 'var(--color-text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</span>
                    <span style={{ fontSize: '0.75rem', color: '#2ED573', fontFamily: 'monospace' }}>{margin}%</span>
                  </div>
                );
              })}
          </div>
        </div>
      )}

      <div className="glass-card" style={{ padding: '1.25rem', marginTop: '1.5rem', background: 'rgba(139,92,246,0.05)', border: '1px solid rgba(139,92,246,0.15)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
          {Icon.sparkle(16)}
          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#a78bfa' }}>Phase 2 Preview</span>
        </div>
        <p style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)', margin: 0 }}>
          Price & stock monitoring history graphs, CSV/PDF export, trend analysis, and advanced charts coming in Phase 2.
        </p>
      </div>
    </div>
  );
}
